import {
  List,
  Datagrid,
  EmailField,
  BooleanField,
  TextField,
  DateField,
  ChipField,
  SearchInput,
  TextInput,
  BooleanInput,
  SelectInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const UserList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <SearchInput source="search" alwaysOn />,
      <TextInput source="email" />,
      <BooleanInput source="isPasswordSet" />,
      <BooleanInput source="isMFARequired" />,
      <SelectInput
        source="role"
        choices={[
          { id: 'USER', name: 'USER' },
          { id: 'ADMIN', name: 'ADMIN' },
        ]}
      />,
      <TextInput source="search" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <EmailField source="email" />
      <BooleanField source="isPasswordSet" />
      <DateField source="lastAuthenticatedAt" />
      <BooleanField source="isMFARequired" />
      <DateField source="verificationEmailSentAt" />
      <ChipField source="role" />
    </Datagrid>
  </List>
)

export const UserShow = () => (
  <Show>
    <SimpleShowLayout>
      <EmailField source="email" />
      <BooleanField source="isPasswordSet" />
      <DateField source="lastAuthenticatedAt" />
      <BooleanField source="isMFARequired" />
      <DateField source="verificationEmailSentAt" />
      <ChipField source="role" />
    </SimpleShowLayout>
  </Show>
)
